(function ($) {
  supercatColumnV1 = {
    formatter: $('.supercat-column-v1')
  };

  Drupal.behaviors.supercatColumnV1 = {
    get: function (key) {
      return supercatColumnV1[key];
    },

    set: function (key, val) {
      supercatColumnV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
      });
    }
  };
})(jQuery);
